import _ from 'lodash';
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
//Components
import {
    Button,
    Form,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    Select,
    ToggleSwitch
} from "@gpstrackit/react-controls";

import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    createPMUserRequest,
    searchDealersRequest,
    updatePMUserRequest,
    usersSearchRolesRequest,
} from 'Redux/actions';

const FIELDS_VALIDATION_LIMITS = {
    firstName: {
        min: 3,
        max: 50
    }, 
    lastName: {
        min: 3,
        max: 50
    },
    username: {
        min: 4,
        max: 50
    },
    email: {
        max: 255
    },
}

const CreateEditUser = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef();

    const { dealers, dealersLoading } = useSelector(state => state.generalRedux);

    const [firstName, setFirstname] = useState("");
    const [lastName, setLastName] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [rol, setRol] = useState([]);
    const [isRestricted, setIsRestricted] = useState(false);
    const [dealerIds, setDealerIds] = useState([]);
    const [dealerId, setDealerId] = useState(null);

    const {
        createUserLoading,
        createUser,
        updateUser,
        updateUserLoading,
        openModal,
        roles,
        getUserLoading,
        user,
        currentId,
    } = useSelector(state => state.usersCreateUserRedux)

    const closeModal = () => {
        dispatch(clearRedux("PM_USERS"));
        setFirstname("");
        setLastName("");
        setUsername("");
        setEmail("");
        setRol([]);
        setIsRestricted(false);
        setDealerIds([]);
        setDealerId(null);
    }

    const saveUser = () => {
        if (!currentId) {
            let rolesIds = rol.map((item) => item.id)
            dispatch(createPMUserRequest({
                firstName,
                lastName,
                username,
                email,
                roles: rolesIds.length ? rolesIds : [],
                isRestricted,
                dealerIds: dealerIds,
                dealerId
            }));
        } else {
            let rolesIds = rol.map((item) => item.id)
            dispatch(updatePMUserRequest({
                firstName,
                lastName,
                id: currentId,
                roleIds: rolesIds.length ? rolesIds : [],
                isRestricted,
                dealerIds: dealerIds,
                dealerId
            }))
        }
    }

    useEffect(() => {
        if (createUser && !createUser?.error) {
            tableRef?.current?.getData();
            NotificationManager.success(
                messages['pmusers_user_has_been_created'],
                messages['pmusers_new_user'],
                3000
            );
            closeModal();
            dispatch(clearRedux("PM_USERS", { createUser: null }))
        } else if (createUser && createUser?.error) {
            NotificationManager.error(
                createUser?.errorMessage || messages['pmusers_message_error_create'],
                messages['pmusers_edit_user'],
                3000
            );
            dispatch(clearRedux("PM_USERS", { createUser: null }))
        }
        if (updateUser && updateUser?.id) {
            tableRef?.current?.getData();
            NotificationManager.success(
                messages['pmusers_user_has_been_edited'],
                messages['pmusers_edit_user'],
                3000
            );
            closeModal();
            dispatch(clearRedux("PM_USERS", { updateUser: null }))
        }
        if (user) {
            setFirstname(user?.firstName || "");
            setLastName(user?.lastName || "");
            setUsername(user?.username || "");
            setEmail(user?.email);
            setRol(user?.roles || []);
            setIsRestricted(user.isRestricted);
            let values = JSON.parse(user.dealerIds);
            let ids = [];
            values = values?.replace("[", "").replace("]", "").split(",");
            if (values?.length > 0) {
                ids = values.map((x, index) => {
                    return _.toInteger(x);
                })
            }
            setDealerIds(ids || []);
            setDealerId(user?.dealerId || null);
        }
    }, [createUser, updateUser, user, currentId]);

    useEffect(() => {
        if (openModal) {
            dispatch(usersSearchRolesRequest())
            dispatch(searchDealersRequest());
        };
        if (!openModal) closeModal();
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={currentId ? messages['pmusers_edit_user'] : messages['pmusers_new_user']}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={createUserLoading || updateUserLoading || getUserLoading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 36 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => saveUser()}
                        autocomplete="nope"
                    >
                        <div style={{ marginTop: 5 }}>
                            <Input
                                type="text"
                                label={messages['pmusers_user_firstname']}
                                placeholder={messages['pmusers_user_firstname']}
                                value={firstName || ""}
                                autoComplete="off"
                                onChange={(value) => setFirstname(value)}
                                requiredMessage={messages['required_field']}
                                required
                                maxLength={FIELDS_VALIDATION_LIMITS.firstName.max}
                                minLength={FIELDS_VALIDATION_LIMITS.firstName.min}
                                minLengthMessage={`${messages['pmusers_min_chars_firname']} ${FIELDS_VALIDATION_LIMITS.firstName.min}`}
                                maxLengthMessage={`${messages['pmusers_max_chars_firname']} ${FIELDS_VALIDATION_LIMITS.firstName.max}`}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Input
                                type="text"
                                label={messages['pmusers_user_lastName']}
                                placeholder={messages['pmusers_user_lastName']}
                                value={lastName || ""}
                                autoComplete="off"
                                onChange={(value) => setLastName(value)}
                                requiredMessage={messages['required_field']}
                                required
                                maxLength={FIELDS_VALIDATION_LIMITS.lastName.max}
                                minLength={FIELDS_VALIDATION_LIMITS.lastName.min}
                                minLengthMessage={`${messages['pmusers_min_chars_lastname']} ${FIELDS_VALIDATION_LIMITS.lastName.min}`}
                                maxLengthMessage={`${messages['pmusers_max_chars_lastname']} ${FIELDS_VALIDATION_LIMITS.lastName.max}`}
                            />
                        </div>
                        {!currentId &&
                            <>
                                <div style={{ marginTop: 5 }}>
                                    <Input
                                        type="text"
                                        label={messages['pmusers_user_username']}
                                        placeholder={messages['pmusers_user_username']}
                                        value={username || ""}
                                        autoComplete="off"
                                        onChange={(value) => setUsername(value)}
                                        requiredMessage={messages['required_field']}
                                        required
                                        maxLength={FIELDS_VALIDATION_LIMITS.username.max}
                                        minLength={FIELDS_VALIDATION_LIMITS.username.min}
                                        minLengthMessage={`${messages['pmusers_min_chars_username']} ${FIELDS_VALIDATION_LIMITS.username.min}`}
                                        maxLengthMessage={`${messages['pmusers_max_chars_username']} ${FIELDS_VALIDATION_LIMITS.username.max}`}
                                    />
                                </div>
                                <div style={{ marginTop: 5 }}>
                                    <Input
                                        type="email" maxLength={FIELDS_VALIDATION_LIMITS.email.max}
                                        label={messages['pmusers_user_email']}
                                        placeholder={messages['pmusers_user_email']}
                                        value={email || ""}
                                        onChange={(value) => setEmail(value)}
                                        requiredMessage={messages['required_field']}
                                        email
                                        emailMessage={messages['pmusers_user_email_is_invalid']}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                            </>
                        }
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="roles"
                                label={messages['pmusers_user_rol']}
                                textField="name"
                                value={rol}
                                valueField="id"
                                options={roles?.filter(x => !x.name.includes("Super Admin")) || []}
                                onChange={(values) => setRol(values)}
                                isClearable
                                requiredMessage={messages['required_field']}
                                required
                                placeholder={messages['select']}
                                multiple
                                selectedOptionsBelow
                            />
                        </div>
                        {
                            <div style={{ marginTop: 5 }}>

                                <div className="time-zone-container" style={{ margin: '10px 0' }}>
                                    <Select
                                        id="dealer"
                                        options={dealers}
                                        value={dealers?.find(x => x.id === dealerId)}
                                        label={messages['pmusers_dealer']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => {
                                            setDealerId(value?.id);
                                        }}
                                        loading={dealersLoading}
                                        valueField="id"
                                        textField="name"
                                        placeholder={messages['create_account_select']}
                                        menuPlacement="top"
                                    />
                                </div>
                                <div className="is-restricted-container">
                                    <label style={{ margin: '10px 0' }} className="input-normal-label">{messages['pmusers_is_restricted']}</label>
                                    <ToggleSwitch
                                        id="is-restricted"
                                        medium
                                        blueToggle
                                        optionLabels={[messages['common_yes'], messages['common_no']]}
                                        checked={isRestricted}
                                        onChange={(checked) => {
                                            setIsRestricted(checked);
                                            if (!checked) {
                                                setDealerIds([]);
                                                setDealerId(1);
                                            }
                                        }}
                                    />
                                </div>
                                {
                                    isRestricted &&
                                    <div className="time-zone-container" style={{ margin: '10px 0' }}>
                                        <Select
                                            id="dealers"
                                            options={dealers}
                                            value={dealers.filter(x => dealerIds?.find(d => d === x.id))}
                                            label={messages['pmusers_dealers']}
                                            required
                                            requiredMessage={messages['required_field']}
                                            onChange={(value) => {
                                                let values = value?.map((dealer, index) => {
                                                    return dealer['id'];
                                                }) || [];
                                                setDealerIds(values);
                                            }}
                                            loading={dealersLoading}
                                            valueField="id"
                                            textField="name"
                                            placeholder={messages['create_account_select']}
                                            multiple
                                            selectedOptionsBelow
                                            menuPlacement="top"
                                        />
                                    </div>
                                }

                            </div>
                        }
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            formRef.current?.submit();
                        }}
                    >
                        {messages['save']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default CreateEditUser;